<res-base-modal [modalTitle]="modalTitle" [modalAutomationId]="modalAutomationId" [modalClass]="modalClass"
    [modalHelpIndex]="modalHelpIndex" [primaryButtonLabel]="primaryButtonLabel" (primaryButtonActionEmt)="ok()"
    (closeButtonActionEmt)="closeModal()" [secondaryButtonLabel]="secondaryButtonLabel"
    [isPrimaryBtnEnabled]="okEnabled()" [(isBusy)]="isBusy" [(isBusyMessage)]="isBusyMessage">


    <div class="name-description-container">
        <res-name-description [validateNameRequest]="validateNameRequest" [validateName]="validateName"
            [automationId]="modalAutomationId">
        </res-name-description>
    </div>
    <div class="button-group">
        <button data-automation-id="create-sample-by-sample-size-button" type="button"
            [ngClass]="sampleType === 'by-size' ? 'btn-group-active' : 'btn-group-default'"
            (click)="setType('by-size')">
            <div>By Sample Size</div>
            <i class="fa fa-caret-up up-caret-active" [hidden]="sampleType != 'by-size'"></i>
        </button>
        <button data-automation-id="create-sample-by-confidence-level-button" type="button"
            [ngClass]="sampleType === 'by-conf-level' ? 'btn-group-active' : 'btn-group-default'"
            (click)="setType('by-conf-level')">
            <div>By Confidence Level</div>
            <i class="fa fa-caret-up up-caret-active" [hidden]="sampleType != 'by-conf-level'"></i>
        </button>
    </div>
    <div class="by-size-container" *ngIf="sampleType == 'by-size'">
        <res-custom-slider allowEditInput="true" min="1" max="100" content="Percentage of Documents:"
            [(selectedValue)]="percentage" hidePlusMinus="true"
            [automationId]="modalAutomationId + '-percentage-of-documents'" [onSelectionChanged]="percentageChange()"
            inputWidth=95>
        </res-custom-slider>
        <span>%</span>
    </div>
    <div class="doc-container" *ngIf="sampleType == 'by-size'">
        <span> Sample Size (Documents) : </span>
        <input type="number" min="1" max="totalDocumentCount"
            onkeypress="return (event.charCode == 8 || event.charCode == 0) ? null : event.charCode >= 48 && event.charCode <= 57"
            [ngModel]="numDocs" name="numDocs" [attr.data-automation-id]="modalAutomationId + '-document-count-input'"
            (ngModelChange)="docCountChange($event)">
        <span> / {{displayTotalDocCount}}</span>
        <div class="fill-empty-container"></div>
    </div>

    <div class="by-conf-level-container" *ngIf="sampleType == 'by-conf-level'">
        <div class="conf-level">
            <res-custom-slider min="90" max="99" allowEditInput="true" content="Confidence Level:"
                [(selectedValue)]="confidenceLevel" [automationId]="modalAutomationId + '-confidence-level'"
                hidePlusMinus="true" [onSelectionChanged]="getSampleSizeDoc()" (_selectedValue)="confidenceLevel"
                inputWidth=95>
            </res-custom-slider>
            <span>%</span>
        </div>
        <div class="margin-error">
            <res-custom-slider min="1" max="5" allowEditInput="true" content="Margin of Error:"
                [(selectedValue)]="confidenceInterval" [automationId]="modalAutomationId + '-margin-of-error'"
                [onSelectionChanged]="getSampleSizeDoc()" (_selectedValue)="confidenceInterval"
                [middleRowTemplate]="plusMinusTemplate" inputWidth=95>
            </res-custom-slider>
            <ng-template #plusMinusTemplate>
                <span> ± </span>
            </ng-template>
        </div>
    </div>
    <div class="sample-size-container" *ngIf="sampleType == 'by-conf-level'">
        <span>Sample Size: </span>
        <span class="sampleSizeValue"
            [attr.data-automation-id]="modalAutomationId + '-size-documents'">{{sampleSizeDoc}}</span>
        <span> documents</span>
    </div>
    <div class="checkbox-container">
        <res-collapsible-toggle-box-group [toggleItems]="toggles" [data-automation-id]="modalAutomationId">
        </res-collapsible-toggle-box-group>
    </div>

</res-base-modal>